import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AgrimotorService } from '../../agrimotor.service';

@Component({
  selector: 'app-ag-add-driver-dialog',
  templateUrl: './add-driver-dialog.component.html',
  styleUrls: ['./add-driver-dialog.component.css', '../../../quote.component.css']
})
export class AgAddDriverDialogComponent implements OnInit {
  @Input() drivers;
  @Input() staticData;
  @Input() authDetails;
  /** Which list on the vehicle this driver is being added to. */
  @Input() target: string = 'drivers';
  @Output() driverAdded = new EventEmitter();
  @Output() cancelled = new EventEmitter();

  mode: string = '';
  selectedDriverId: string = '';
  newDriver: any = { title: '', first_name: '', last_name: '' };
  errorMessage: string = '';
  isCreating: boolean = false;

  constructor(private agService: AgrimotorService) { }

  ngOnInit(): void { }

  selectExistingDriver() {
    if (!this.selectedDriverId) {
      this.errorMessage = 'Please select a driver.';
      return;
    }
    this.errorMessage = '';
    this.driverAdded.emit({ type: 'existing', target: this.target, driver_id: this.selectedDriverId });
  }

  createNewDriver() {
    if (!this.newDriver.title || !this.newDriver.first_name || !this.newDriver.last_name) {
      this.errorMessage = 'Please enter the driver\'s title, forename(s) and surname.';
      return;
    }
    this.errorMessage = '';
    this.isCreating = true;

    // Driver ids must come from the agri-api's generate-id endpoint — a locally
    // invented id is not a reference the insurer can resolve.
    this.agService.getUniqueID(this.authDetails).subscribe(
      (response: any) => {
        this.isCreating = false;
        const id = response?.meta?.id;
        if (!id) {
          this.errorMessage = 'Could not create the driver right now. Please try again.';
          return;
        }
        this.emitNewDriver(id);
      },
      () => {
        this.isCreating = false;
        this.errorMessage = 'Could not create the driver right now. Please try again.';
      }
    );
  }

  private emitNewDriver(id: string) {
    this.driverAdded.emit({
      type: 'new',
      target: this.target,
      driver: {
        id: id,
        title: this.newDriver.title,
        first_name: this.newDriver.first_name,
        last_name: this.newDriver.last_name,
        // The remaining mandatory detail is collected on the Drivers page.
        dob: '', licence_type: '', licence_length: '',
        additional_trades: [], claims: [], convictions: [],
      }
    });
    this.newDriver = { title: '', first_name: '', last_name: '' };
    this.mode = '';
  }

  cancel() { this.cancelled.emit(); }
}
